/**
 * 文件说明:
 *
 * hz dva config
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {globalActionsType} from 'utils/dva'
import * as Sentry from 'utils/sentry'
import {hzDvaConfigMerge} from 'umi'

export function dva(config) {
    return hzDvaConfigMerge(config, {
        config: {
            namespacePrefixWarning: false,
            onError(err) {
                // err.preventDefault()
                Sentry.withScope((scope) => {
                    scope.setTag('dva', 'onError')
                    Sentry.captureException(err)
                })
                console.error('dva', err)
                // message.error(err.message)
            },
            initialState: {},
            onAction: [],
            onReducer(combineReducers) {
                return (state, action) => {
                    if (action.type === globalActionsType.logout) {
                        const {router, base} = state
                        state = {router, base}
                    } else if (action.type === globalActionsType.resetState) {
                        const {namespace} = action.payload
                        delete state[namespace]
                    }

                    return combineReducers(state, action)
                }
            },
        },
    })
}
